import React, { PropsWithChildren, type ReactElement } from 'react';

import { Tooltip } from '@pushwoosh/dumb-components';

import { useLang } from '~/src/polyglot';

export function AccountTooltip({ isAllowSelect, children }: PropsWithChildren<{ isAllowSelect: boolean }>): ReactElement {
  const lang = useLang();

  return (
    !isAllowSelect ? (
      <Tooltip
        position="top-middle"
        content={lang({ message: 'SELECT_ACCOUNT.TOOLTIP.MULTIUSER' })}
        maxWidth={320}
      >
        <div>{children}</div>
      </Tooltip>
    ) : <div>{children}</div>
  );
}
